<template lang="pug">
	.creative-producer-request
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')")
		Popup(v-if="producerRequestPopupVisible", :popupVisible.sync="producerRequestPopupVisible", :width="640", :height="230", :title="$tCaption('Ask Expert')", :autosize="true")
			.flex-col.space-medium
				Loader(v-if="isLoading", text="", :fullscreen="true")
				.flex-col.space(:class="{ 'disabled-controls': isLoading }")
					.font-small.upper.grey {{$tCaption('Question')}}
					DxTextArea(:value.sync="question", valueChangeEvent="input", stylingMode="filled", height="200px")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="producerRequestPopupVisible = false")
				DxButton(:text="$tCaption('Send', '@actions')", @click="sendRequest", :disabled="!question || !!isLoading", type="default")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'creative.ProducerRequest',
		name: 'creative-producer-request',
		components: {
			Loader, Popup, DxTextArea, DxButton, DxCheckBox
		},
		props: ['creative'],
		data() {
			return {
				isLoading: false,
				producerRequestPopupVisible: false,
				question: null
			};
		},
		computed: {
			requestId() {
				return this.$route.query?.requestId;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeProducerRequest = this;
		},
		methods: {
			show() {
				this.producerRequestPopupVisible = false;
				this.question = null;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.producerRequestPopupVisible = true;
				});
			},
			sendRequest() {
				this.isLoading++;
				this.$Data.postExternalApi('AudioProducer/AskExpert', {
					Question: this.question,
					CreativeId: this.creative?.Oid
				}).then(r => {
					if (r?.Success !== false) {
						this.$notifySuccess(this.$tCaption('Producer request has been successfully created.'));
					} else {
						this.$notifyError(r?.ErrorMessage);
					}
				}).finally(() => this.isLoading--)
				this.producerRequestPopupVisible = false;
			},
			finish() {
				if (__DEBUG__)
					console.debug('Producer request finish', this.requestId);
				this.$confirm(void 0, this.$tCaption('Do you want to finish with this creative?')).then(() => {
					
				});
			},
		}
	};
</script>
<style lang='scss'>
	.creative-producer-request{
	}
</style>
